// extracted by mini-css-extract-plugin
export default {"header":"ProductsWrapper_header__-U2LU","action":"ProductsWrapper_action__zNPOA","sort":"ProductsWrapper_sort__09m3-"};